module.exports = __webpack_public_path__ + "img/logo.59eb417c.svg";